<template>
  <iRichText
    ref="richTextElement"
    v-model="value"
    :handle-link-modal-open="handleLinkModalOpen"
    :show-bubble-menu="true"
    :show-toolbar="false"
    :style-overrides="{
      paddingLeft: 'small',
      paddingRight: 'small',
      paddingTop: '1px',
      paddingBottom: '1px',
      placeholderFontSize: 'small',
      borderWidth: 'standard',
      borderRadius: getOptionValue(BorderRadius)
    }"
    :text-style-overrides="{
      standardFontSize: 'small',
      standardHoverFontSize: 'small'
    }"
    :tools-to-disable="['text-align', 'bullet-list']"
    :width="getOptionValue(LayoutWidth)"
    break-word
    height="hug"
    placeholder="Enter text here"
  />

  <teleport to="body">
    <RichTextDestinationPickerModal
      :link-data="linkData"
      :original-link-value="originalLinkData.linkValue"
      :publication-id="useFanPublicationStore().publicationId"
      :rich-text-ref="$refs.richTextElement"
      :show="showLinkModal"
      @close="handleLinkModalClose"
      @update="linkData = {...linkData, ...$event}"
    />
  </teleport>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import useFanPublicationStore from "%/stores/fan-publication-store";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import BorderRadius from "%/dynamic-components/render-engine/options/border-options/border-radius";
import RichTextDestinationPickerModal from "%/components/RichTextDestinationPickerModal.vue";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";

export default {
  name: "DynamicAppRichTextInputElement",
  components: { RichTextDestinationPickerModal },
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  emits: ["update:modelValue"],
  data() {
    return {
      showLinkModal: false,
      linkData: {},
      originalLinkData: {},
    };
  },
  hidden: true,
  options: [
    LayoutWidth,
    new LayoutHeight(undefined, true),
  ],
  optionBundles: [
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  computed: {
    BorderRadius() {
      return BorderRadius;
    },
    LayoutWidth() {
      return LayoutWidth;
    },
    isEditable() {
      return true;
    },
    value: {
      get() {
        try {
          return JSON.parse(this.valueFromContext);
        } catch (e) {
          return this.valueFromContext;
        }
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = JSON.stringify(value);
        }
      },
    },
  },
  methods: {
    useFanPublicationStore,
    handleLinkModalOpen(event) {
      this.linkData = event;
      this.originalLinkData = event;
      this.showLinkModal = true;
    },
    handleLinkModalClose() {
      this.linkData = {};
      this.originalLinkData = {};
      this.showLinkModal = false;
    },
    handleChange(value) {
      this.value = value;
      this.$emit("update:modelValue", value);
    },
  },
  styleGuide: () => ({
    smallSpacing: { "size.spacing": "small" },
  }),
};
</script>

<style lang="scss" scoped>
:deep(.i-text) {
  width: -webkit-fill-available !important;
  width: -moz-available !important;
  line-height: 2 !important;
  word-break: break-all;
}
</style>
